// import { APP_NAME } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import { ErrorPage } from '@pages/404';
import PropTypes from 'prop-types';
import React from 'react';
import { Switch } from 'react-router-dom';

import { DashboardRoute } from '../../layouts';
import {
  BulkTransferPage,
  PayoutsHistory,
  PayoutsSummary,
  ReceivePayoutPage,
  SingleTransferPage
} from '.';

const PayoutRoutes = () => {
  return (
    <Switch>
      <TransferPageRoute path="/payouts/bulk-transfer">
        <BulkTransferPage />
      </TransferPageRoute>
      <TransferPageRoute path="/payouts/single-transfer">
        <SingleTransferPage />
      </TransferPageRoute>
      <DashboardRoute path="/payouts/history">
        <PayoutsHistory />
      </DashboardRoute>
      <DashboardRoute exact path="/payouts/receive">
        <ReceivePayoutPage />
      </DashboardRoute>
      <DashboardRoute path="/payouts/:tab?/:id?">
        <PayoutsSummary />
      </DashboardRoute>
    </Switch>
  );
};

const TransferPageRoute = ({ props, requiredPermission, children }) => {
  // const [token] = useSessionStorage(APP_NAME, '');
  const hasPermission = useHasPermission();

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <ErrorPage />;
  }

  // const { TwoFaEnabled } = token;

  // return TwoFaEnabled ? (
  //   <DashboardRoute {...props}>{children}</DashboardRoute>
  // ) : (
  //   <Redirect to="/payouts" />
  // );

  return <DashboardRoute {...props}>{children}</DashboardRoute>;
};

TransferPageRoute.propTypes = {
  props: PropTypes.object,
  children: PropTypes.node,
  requiredPermission: PropTypes.string
};

export { PayoutRoutes };
